import React from 'react';
import { useNotifications } from '../../contexts/NotificationContext';
import SystemAlert from './SystemAlert';

const SystemAlertContainer: React.FC = () => {
  const { systemAlerts } = useNotifications();

  if (systemAlerts.length === 0) {
    return null;
  }

  return (
    <div className="space-y-2 mb-4">
      {systemAlerts.map((alert) => (
        <SystemAlert key={alert.id} alert={alert} />
      ))}
    </div>
  );
};

export default SystemAlertContainer;